import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-cdcbddca")

_pushScopeId("data-v-cdcbddca")
const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = { class: "dropdown_list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Popup = _resolveComponent("Popup")

  return (_ctx.isVisible)
    ? (_openBlock(), _createBlock(_component_Popup, {
        key: 0,
        showHeader: false,
        style: _ctx.dropdownPosition,
        type: _ctx.dropdownType
      }, {
        body: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.divisions, (div, idx) => {
                return (_openBlock(), _createBlock("div", {
                  key: idx,
                  class: "dropdown_item",
                  onClick: ($event: any) => (_ctx.select(idx))
                }, _toDisplayString(div), 9, ["onClick"]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["style", "type"]))
    : _createCommentVNode("", true)
})